import React from 'react';
import { Button } from 'react-bootstrap';

import { getNameInCurrentLanguage } from 'helpers/intl';

import CmsTextColorSelector from 'components/cms/settings/components/CmsTextColorSelector';

import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormRichEditor from 'components/forms/FormRichEditor';

export default class CmsElementQuestionnaire extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSelectQuestionnaire: false,
      showSelectPipeline: false,
    };
  }

  setQuestionnaire = (name, questionnaire) => {
    const { setParams } = this.props;

    if (questionnaire) {
      setParams([
        { name: 'questionnaireName', value: questionnaire.name },
        { name: 'questionnaireId', value: questionnaire.id },
      ]);
      this.setState({ showSelectQuestionnaire: false });
    } else {
      setParams([{ name: 'questionnaireName', value: null }, { name: 'questionnaireId', value: null }]);
    }
  };

  setPipeline = (name, pipeline) => {
    const { appIntl, setParams } = this.props;

    if (pipeline) {
      setParams([
        { name: 'pipelineName', value: getNameInCurrentLanguage(pipeline.name, appIntl) },
        { name: 'pipelineId', value: pipeline.id },
      ]);
      this.setState({ showSelectPipeline: false });
    } else {
      setParams([{ name: 'pipelineName', value: null }, { name: 'pipelineId', value: null }]);
    }
  };

  render() {
    const {
      intl: { messages },
      setParam,
      getParamValue,
      navigateBack,
    } = this.props;
    const { showSelectQuestionnaire, showSelectPipeline } = this.state;

    const questionnaireId = getParamValue('questionnaireId');
    const pipelineId = getParamValue('pipelineId');

    return (
      <>
        <div className="m-b-20">
          <a
            href="#back"
            className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-5 p-b-5 text-master b-rad-lg"
            onClick={navigateBack}
          >
            <i className="fa fa-angle-left m-r-5" /> {messages.back}
          </a>

          <b>{messages.questionnaire}</b>
        </div>

        <div class="form-group-attached">
          <p>
            {messages.settings} <b>{messages.questionnaire}</b>
          </p>

          <CmsTextColorSelector label={messages.text_color} {...this.props} />
          <FormInput label={messages.title} name="title" onChange={setParam} value={getParamValue('title')} />

          {!questionnaireId || showSelectQuestionnaire ? (
            <FormAutocomplete
              name="questionnaire"
              autocompleteType="questionnaire"
              label={messages.questionnaire}
              returnValueObject
              onChange={this.setQuestionnaire}
              value={questionnaireId}
            />
          ) : (
            <div class="form-group form-group-default padding-10">
              <label>{messages.questionnaire}</label>
              <span>{getParamValue('questionnaireName')}</span>
              <Button
                class="m-l-10 btn-rounded"
                bsSize="xs"
                onClick={() => this.setState({ showSelectQuestionnaire: true })}
              >
                {messages.change_questionnaire}
              </Button>
            </div>
          )}

          {!pipelineId || showSelectPipeline ? (
            <FormAutocomplete
              name="pipeline"
              autocompleteType="pipeline"
              label={messages.pipeline}
              returnValueObject
              onChange={this.setPipeline}
              value={pipelineId}
            />
          ) : (
            <div class="form-group form-group-default padding-10">
              <label>{messages.pipeline}</label>
              <span>{getParamValue('pipelineName')}</span>
              <Button
                class="m-l-10 btn-rounded"
                bsSize="xs"
                onClick={() => this.setState({ showSelectPipeline: true })}
              >
                {messages.change_pipeline}
              </Button>
            </div>
          )}

          <FormInput
            name="buttonTitle"
            label={messages.button_text}
            onChange={setParam}
            value={getParamValue('buttonTitle')}
          />

          <FormInput
            name="leadSource"
            label={messages.lead_source}
            onChange={setParam}
            value={getParamValue('leadSource')}
          />
          <FormRichEditor
            label={messages.response_text}
            name="thankYouText"
            onChange={setParam}
            value={getParamValue('thankYouText')}
          />
        </div>
      </>
    );
  }
}
